import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NavigationService } from '@core/services/navigation/navigation.service';
import { ProductsService } from '@core/services/products/products.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class DebitFromDepositCommand extends BaseProductCommand {
  readonly type = 'debit-from-deposit';
  readonly title = 'Списать';
  readonly icon = 'forward';
  readonly productType = ProductTypes.DEPOSIT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 3; // Третий в actions для deposit

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService,
    private productsService: ProductsService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push('payments/transfer/self', {
      queryParams: { accId: context.data.id }
    });
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): Observable<boolean> | boolean {
    return this.productsService.checkAvailableDebitFromDeposit(context.data);
  }
}
